import { queryOptions } from '@tanstack/react-query';
import { DASHBOARD_DEVICES_HEALTH_QUERY_KEY_PREFIX } from '@/lib/merchant-stream';
import {
  getMerchantDevicesHealth,
  getMerchantReceipts,
  getMerchantSummary,
} from './dashboard.service';
import type {
  MerchantDevicesHealthQueryParams,
  MerchantReceiptsQueryParams,
  MerchantSummaryQueryParams,
} from './types';

export function merchantSummaryQueryOptions(params: MerchantSummaryQueryParams) {
  return queryOptions({
    queryKey: [
      'dashboard',
      'merchant-summary',
      params.period,
      params.from ?? null,
      params.to ?? null,
      params.branch_id ?? null,
    ],
    queryFn: () => getMerchantSummary(params),
    staleTime: 60_000,
  });
}

export function dashboardRecentReceiptsQueryOptions(params: MerchantReceiptsQueryParams) {
  return queryOptions({
    queryKey: [
      'dashboard',
      'recent-receipts',
      params.period ?? null,
      params.from ?? null,
      params.to ?? null,
      params.branch_id ?? null,
      params.page ?? null,
      params.page_size ?? null,
    ],
    queryFn: () => getMerchantReceipts(params),
    staleTime: 15_000,
  });
}

export function merchantDevicesHealthQueryOptions(params: MerchantDevicesHealthQueryParams) {
  return queryOptions({
    queryKey: [...DASHBOARD_DEVICES_HEALTH_QUERY_KEY_PREFIX, params.branch_id ?? null],
    queryFn: () => getMerchantDevicesHealth(params),
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
  });
}
